import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/footer/Footer";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const LoginPage = () => {
  const [step, setStep] = useState(1); // 1: login form, 2: OTP form
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotOtpSent, setForgotOtpSent] = useState(false);
  const [forgotOtp, setForgotOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const { login } = useAuth();
  const navigate = useNavigate();

  // 1️⃣ Step 1: Username + Password → Trigger OTP to email
  const handleInitialLogin = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${apiBaseUrl}/login-step1`, { username, password });
      alert(res.data.message || "OTP sent to your email.");
      setEmail(res.data.email); // for showing in UI
      setStep(2);
    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  // 2️⃣ Step 2: Verify OTP
  const handleVerifyOTP = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${apiBaseUrl}/login-step2`, { username, otp });
      if (res.data.token) {
        login(res.data.token);
        navigate("/admin/dashboard");
      } else {
        alert("Invalid OTP or login failed.");
      }
    } catch (err) {
      alert(err.response?.data?.message || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  // 🔁 Forgot Password Flow
  const handleSendForgotOTP = async () => {
    try {
      const res = await axios.post(`${apiBaseUrl}/forgot-password`, { email });
      alert(res.data.message);
      setForgotOtpSent(true);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to send OTP");
    }
  };

  const handleResetPassword = async () => {
    try {
      const res = await axios.post(`${apiBaseUrl}/reset-password`, {
        email,
        otp: forgotOtp,
        newPassword,
      });
      alert(res.data.message);
      setShowForgotModal(false);
      setForgotOtpSent(false);
      setEmail("");
      setForgotOtp("");
      setNewPassword("");
    } catch (err) {
      alert(err.response?.data?.message || "Failed to reset password");
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      <div style={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div style={{ background: "#fff", padding: "30px", borderRadius: "12px", width: "100%", maxWidth: "400px", textAlign: "center", boxShadow: "0 8px 20px rgba(0,0,0,0.2)", marginTop: "20px",marginBottom: "20px" }}>
          <img src="/assets/logo.png" alt="Logo" style={{ width: "200px", marginBottom: "20px" }} />
          <h2>Admin Login</h2>

          {step === 1 ? (
            <>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={inputStyle}
              />
              <div style={{ position: "relative", marginBottom: "20px" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ ...inputStyle, paddingRight: "40px" }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                >
                  {showPassword ? "👁️" : "🔒"}
                </span>
              </div>
              <button onClick={handleInitialLogin} disabled={loading} style={buttonStyle}>
                {loading ? "Sending OTP..." : "Login"}
              </button>
            </>
          ) : (
            <>
              <p style={{ marginBottom: "16px" }}>OTP sent to <strong>{email}</strong></p>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                style={inputStyle}
              />
              <button onClick={handleVerifyOTP} disabled={loading} style={buttonStyle}>
                {loading ? "Verifying..." : "Verify & Login"}
              </button>
            </>
          )}

          <p style={{ marginTop: "16px", color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
             onClick={() => {
               setShowForgotModal(true);
               setEmail("");
             }}
          >
            Forgot Password?
          </p>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgotModal && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <h3 style={{ marginBottom: "20px" }}>Forgot Password</h3>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={inputStyle}
            />
            {forgotOtpSent && (
              <>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={forgotOtp}
                  onChange={(e) => setForgotOtp(e.target.value)}
                  style={inputStyle}
                />
                <input
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  style={inputStyle}
                />
              </>
            )}
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
              {!forgotOtpSent ? (
                <button onClick={handleSendForgotOTP} style={greenButton}>
                  Send OTP
                </button>
              ) : (
                <button onClick={handleResetPassword} style={blueButton}>
                  Reset Password
                </button>
              )}
              <button
                onClick={() => {
                  setShowForgotModal(false);
                  setForgotOtpSent(false);
                  setForgotOtp("");
                  setNewPassword("");
                }}
                style={redButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "16px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "16px",
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  backgroundColor: "#307536",
  color: "white",
  border: "none",
  borderRadius: "8px",
  fontSize: "16px",
  cursor: "pointer",
  fontWeight: "bold",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "30px",
  borderRadius: "12px",
  width: "100%",
  maxWidth: "400px",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
  textAlign: "center",
};

const greenButton = { padding: "10px 20px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" };
const blueButton = { padding: "10px 20px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" };
const redButton = { padding: "10px 20px", backgroundColor: "#dc3545", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" };

export default LoginPage;
